export default __webpack_public_path__ + "static/media/clap.f9894b07.svg";